const ROLE_ADMIN = 'admin';
const ROLE_SERVICE_MANAGER = 'service_manager';
const ROLE_ENGINEER = 'engineer';

const ACTIONS = {
  'dashboard.read': [ROLE_ADMIN, ROLE_SERVICE_MANAGER, ROLE_ENGINEER],
  'workflows.read': [ROLE_ADMIN, ROLE_SERVICE_MANAGER, ROLE_ENGINEER],
  'workflows.write': [ROLE_ADMIN, ROLE_SERVICE_MANAGER],
  'assets.read': [ROLE_ADMIN, ROLE_SERVICE_MANAGER, ROLE_ENGINEER],
  'assets.write': [ROLE_ADMIN, ROLE_SERVICE_MANAGER, ROLE_ENGINEER],
  'tasks.read': [ROLE_ADMIN, ROLE_SERVICE_MANAGER, ROLE_ENGINEER],
  'tasks.write': [ROLE_ADMIN, ROLE_SERVICE_MANAGER, ROLE_ENGINEER],
  'short_urls.read': [ROLE_ADMIN, ROLE_SERVICE_MANAGER, ROLE_ENGINEER],
  'short_urls.write': [ROLE_ADMIN, ROLE_SERVICE_MANAGER, ROLE_ENGINEER],
  'kits.read': [ROLE_ADMIN, ROLE_SERVICE_MANAGER, ROLE_ENGINEER],
  'kits.write': [ROLE_ADMIN, ROLE_SERVICE_MANAGER, ROLE_ENGINEER],
  'users.list': [ROLE_ADMIN, ROLE_SERVICE_MANAGER],
  'users.invite': [ROLE_ADMIN, ROLE_SERVICE_MANAGER],
  'users.modify': [ROLE_ADMIN, ROLE_SERVICE_MANAGER],
  'reports.read': [ROLE_ADMIN, ROLE_SERVICE_MANAGER],
  'integrations.manage': [ROLE_ADMIN],
  'api_tokens.manage': [ROLE_ADMIN],
  'organization.settings': [ROLE_ADMIN],
  // Mirrors backend Permission::ACTIONS tag_tree_manage / tag_assign (app/services/permission.rb).
  'tags.manage': [ROLE_ADMIN],
  'tags.assign': [ROLE_ADMIN, ROLE_SERVICE_MANAGER],
};

export const USER_ROLES = {
  ADMIN: ROLE_ADMIN,
  SERVICE_MANAGER: ROLE_SERVICE_MANAGER,
  ENGINEER: ROLE_ENGINEER,
};

/**
 * Every role, most privileged first. The single place that decides which roles exist and
 * in what order they are offered, so a new role cannot reach one picker and miss another.
 */
export const USER_ROLE_ORDER = [ROLE_ADMIN, ROLE_SERVICE_MANAGER, ROLE_ENGINEER];

/**
 * `{ value, label }` pairs for a role `<select>`, so no screen writes role labels by hand.
 * Pass `roles` to change the order or narrow the list.
 */
export function roleOptions(roles = USER_ROLE_ORDER) {
  return roles.map((role) => ({ value: role, label: roleLabel(role) }));
}

export function can(user, action) {
  if (!user || user.deactivated_at) return false;
  const allowed = ACTIONS[action];
  if (!allowed) return false;
  return allowed.includes(user.role);
}

export function canInviteRole(actor, targetRole) {
  if (!can(actor, 'users.invite')) return false;
  if (!Object.values(USER_ROLES).includes(targetRole)) return false;
  if (actor.role === ROLE_ADMIN) return true;
  return targetRole !== ROLE_ADMIN;
}

export function canModifyUser(actor, targetUser) {
  if (!can(actor, 'users.modify')) return false;
  if (!targetUser) return false;
  if (actor.id === targetUser.id) return false;
  if (actor.role === ROLE_ADMIN) return true;
  return targetUser.role !== ROLE_ADMIN;
}

export function canAssignRole(actor, targetUser, nextRole) {
  if (!canModifyUser(actor, targetUser)) return false;
  if (!Object.values(USER_ROLES).includes(nextRole)) return false;
  if (actor.role === ROLE_ADMIN) return true;
  return nextRole !== ROLE_ADMIN;
}

export function roleLabel(role) {
  return {
    [ROLE_ADMIN]: 'Admin',
    [ROLE_SERVICE_MANAGER]: 'Service manager',
    [ROLE_ENGINEER]: 'Engineer',
  }[role] || 'Unknown';
}
